import { useTranslation } from "react-i18next";
import PrimaryBtn from "../../components/buttons/PrimaryBtn";
import PrimaryTextBtn from "../../components/buttons/PrimaryTextBtn";
import { useNavigate } from "react-router-dom";
import BackBtn from "../../components/buttons/BackBtn";

export default function PortfolioStageArt() {
  const { t } = useTranslation();

  const navigate = useNavigate();
  return (
    <div className="md:px-20 isolate px-6 lg:px-8 flex flex-1 items-center justify-center max-w-5xl">
      <div className="w-full flex flex-col justify-center items-start py-10 md:py-10">

        <BackBtn></BackBtn>

        <div className="text-left mb-16 w-full">
          <h1 className="mb-20 tx1 text-center">
            {t("portfolio.projects.stageart.name")}
          </h1>
          <p className="mt-10 tm2">
            {t("portfolio.projects.stageart.goal")}
          </p>
          <p className="mt-5 tm2">
            {t("portfolio.projects.stageart.description")}
          </p>
          <p className="mt-5 tm2">
            {t("portfolio.projects.stageart.demoNote")}
          </p>

          <div className="flex mt-10 w-full">
            <PrimaryBtn
              to="http://136.113.70.83"
              targetBlank
              fullWidth={false}
              className="max-w-xs mx-auto"
            >
              {t("portfolio.demoBtn")}
            </PrimaryBtn>
          </div>

          <div className="flex flex-col items-center justify-center mt-10 mx-auto gap-4">
            <a
              href="http://136.113.70.83"
              className="card-image"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/assets/projects/stage-art.jpg"
                alt="StageArt"
                className="rounded-lg shadow-md"
              />
            </a>
          </div>
        </div>

        <div className="w-full">
          <h2 className="tx2 text-left mb-4 md:mb-8">
            {t("portfolio.projects.stageart.featuresTitle")}
          </h2>

          <h3 className="tx3 mb-2 md:mb-8">
            {t("portfolio.projects.stageart.generalTitle")}
          </h3>
          <ul className="list-primary-dot ml-6 tm1">
            <li>{t("portfolio.projects.stageart.general1")}</li>
            <li>{t("portfolio.projects.stageart.general2")}</li>
            <li>{t("portfolio.projects.stageart.general3")}</li>
          </ul>

          <div className="card-image mt-10">
            <img
              src="/assets/projects/stage-art-1.jpg"
              alt="StageArt Features"
              className="rounded-lg shadow-md"
            />
          </div>

          <div className="tm1 mb-10 mt-20">
            {t("portfolio.projects.stageart.registerNote")}
            <b className="highlight">
              {t("portfolio.projects.stageart.artist")}
            </b>
            , <b className="highlight">
              {t("portfolio.projects.stageart.manager")}
            </b> {t("portfolio.projects.stageart.or")} <b className="highlight">
              {t("portfolio.projects.stageart.promoter")}
            </b>.
          </div>

          <h3 className="tx3 mb-2 md:mb-8">
            {t("portfolio.projects.stageart.forArtistsTitle")}
          </h3>
          <ul className="list-primary-dot ml-6 tm1">
            <li>{t("portfolio.projects.stageart.artist1")}</li>
            <li>{t("portfolio.projects.stageart.artist2")}</li>
            <li>{t("portfolio.projects.stageart.artist3")}</li>
            <li>{t("portfolio.projects.stageart.artist4")}</li>
          </ul>

          <div className="card-image mt-10">
            <img
              src="/assets/projects/stage-art-4.jpg"
              alt="For Artists"
              className="rounded-lg shadow-md"
            />
          </div>

          <h3 className="tx3 mb-2 md:mb-8 mt-20">
            {t("portfolio.projects.stageart.forManagersTitle")}
          </h3>
          <ul className="list-primary-dot ml-6 tm1">
            <li>{t("portfolio.projects.stageart.manager1")}</li>
            <li>{t("portfolio.projects.stageart.manager2")}</li>
            <li>{t("portfolio.projects.stageart.manager3")}</li>
          </ul>

          <div className="card-image mt-10">
            <img
              src="/assets/projects/stage-art-3.jpg"
              alt="For Managers"
              className="rounded-lg shadow-md"
            />
          </div>

          <h3 className="tx3 mb-2 md:mb-8 mt-20">
            {t("portfolio.projects.stageart.forPromotersTitle")}
          </h3>
          <ul className="list-primary-dot ml-6 tm1">
            <li>{t("portfolio.projects.stageart.promoter1")}</li>
            <li>{t("portfolio.projects.stageart.promoter2")}</li>
            <li>{t("portfolio.projects.stageart.promoter3")}</li>
          </ul>

          <div className="card-image mt-10">
            <img
              src="/assets/projects/stage-art-2.jpg"
              alt="For Promoters"
              className="rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
